<template>
  <div v-loading="loading">
    <div class="title">实名认证</div>
    <el-divider></el-divider>
    <el-form
      ref="profileInfo"
      :model="profileInfo"
      :rules="profileInfoRules"
      label-width="130px"
      inline-message
    >
      <el-form-item label="真实姓名：" prop="realname">
        <el-input
          class="w-300"
          v-model="profileInfo.realname"
          placeholder="请输入真实姓名"
        />
      </el-form-item>
      <el-form-item label="身份证号：" prop="id_number">
        <el-input
          class="w-300"
          v-model="profileInfo.id_number"
          placeholder="请输入身份证号"
        />
      </el-form-item>
      <el-form-item label="身份证正面：" prop="id_card_front_file.id">
        <UploadImageWaterMark
          space="_for_expert_sub_project"
          folder="fuwu"
          :api="api"
          uploadWidth="upload-w-295"
          :uploadLimit="500"
          :cover_url.sync="profileInfo.id_card_front_file.path"
          :cover_file_id.sync="profileInfo.id_card_front_file.id"
        />
      </el-form-item>
      <el-form-item label="身份证反面：" prop="id_card_back_file.id">
        <UploadImageWaterMark
          space="_for_expert_sub_project"
          folder="fuwu"
          :api="api"
          uploadWidth="upload-w-295"
          :uploadLimit="500"
          :cover_url.sync="profileInfo.id_card_back_file.path"
          :cover_file_id.sync="profileInfo.id_card_back_file.id"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">
          保存
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="text/javascript">
import UploadImageWaterMark from "@/components/UploadImageWaterMark";
import API from "@/global/request/api";
import settingService from "@/global/service/setting";

export default {
  components: {
    UploadImageWaterMark
  },
  data() {
    return {
      loading: true,
      btnLoading: false,
      api: API.settingFile,
      profileInfo: {
        realname: "",
        id_number: "",
        id_card_front_file: {
          id: null,
          path: ""
        },
        id_card_back_file: {
          id: null,
          path: ""
        }
      },
      profileInfoRules: {
        realname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" }
        ],
        id_number: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern: /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/,
            message: "格式错误"
          }
        ],
        "id_card_front_file.id": [
          { required: true, message: "请上传身份证正面", trigger: "blur" }
        ],
        "id_card_back_file.id": [
          { required: true, message: "请上传身份证反面", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      settingService
        .realNameVerifies()
        .then(res => {
          res.id_card_front_file = res.id_card_front_file
            ? res.id_card_front_file
            : {
                id: null,
                path: ""
              };
          res.id_card_back_file = res.id_card_back_file
            ? res.id_card_back_file
            : {
                id: null,
                path: ""
              };
          this.profileInfo = res;
        })
        .finally(() => (this.loading = false));
    },
    handleSubmit() {
      const params = {
        realname: this.profileInfo.realname,
        id_number: this.profileInfo.id_number,
        id_card_front_file_id: this.profileInfo.id_card_front_file.id,
        id_card_back_file_id: this.profileInfo.id_card_back_file.id
      };
      this.$refs["profileInfo"].validate(val => {
        if (!val) {
          this.$message.error("缺少必要参数");
          return;
        }
        this.btnLoading = true;
        settingService
          .editRealNameVerifies(params)
          .then(() => {
            this.$message.success("保存成功");
            this.$store.dispatch("settingSatage");
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    }
  }
};
</script>
